import fly, { genFormData } from './fly'
import { getAuth } from '@/util/storage'
const auth = getAuth()

//购物车商品列表
export const fetchShopingCar = (depot_id: string) =>
  fly.get('/mall/cs/shoppingbag/get.json', { depot_id, auth })

//商品详情
export const fetchGoodsDetail = (depot_id: string, id: string) =>
  fly.get('/mall/cs/goods/get.json', { depot_id, id, auth })

//清空购物袋中已经售罄的商品
export const clearCarApi = (params: any) =>
  fly.post('/mall/cs/shoppingbag/clear.json', genFormData({ ...params, auth }))

//准备订单
export const orderPrepareApi = (params: any, type: string) => {
  if (type === 'new') {
    return fly.post('/mall/cs/order/prepare.json', { ...params, auth })
  } else {
    return fly.post('/mall/cs/order/prepare2.json', { ...params, auth })
  }
}

//更新用户优惠券状态
export const couponFlushApi = (params: any, type: string) => {
  if (type === 'new') {
    return fly.post('/mall/coupon/flush.json', { ...params, auth })
  } else {
    return fly.post('/mall/coupon/flush2.json', { ...params, auth })
  }
}

//订单价格信息
export const balanceInfoApi = (params: any, type: string) => {
  if (type === 'new') {
    return fly.post('/mall/cs/order/balance-info.json', { ...params, auth })
  } else {
    return fly.post('/mall/cs/order/balance-info2.json', { ...params, auth })
  }
}

//创建订单new
export const createOrderApi = (params: any, type: string) => {
  if (type === 'new') {
    return fly.post('/mall/cs/order/create2.json', { ...params, auth })
  } else {
    return fly.post('/mall/cs/order/create3.json', { ...params, auth })
  }
}

//订单简易详情
export const simpleDetailApi = (order_sn: string) =>
  fly.get('/mall/cs/order/simpleDetail.json', { order_sn, auth })
//订单列表
export const orderListApi = (type: string, page: number) =>
  fly.get('/mall/cs/order/get.json', { type, page, auth })
//确认支付
export const confirmPayApi = (params: any) =>
  fly.post('/mall/cs/order/confirmPay.json', { ...params, auth })
//获取订单支付详情
export const payInfoApi = (out_trade_no: any) =>
  fly.post('/mall/order/pay.json', genFormData({ out_trade_no, auth }))
//通过order_sn得到购买信息
export const buyInfoApi = (depot_id: string, order_sn: string) =>
  fly.get('/mall/cs/order/buy-info.json', { depot_id, order_sn, auth })
